import type { SimulationConfig } from '../../config/schema';
import type { ControlSetupContext } from './helpers';
import { bindRangeParam } from './helpers';

export function setupSystemControls(ctx: ControlSetupContext): void {
  const { config: c, controls: ui } = ctx;

  ui.bindControl('systemType', (v) => {
    c.system = v as SimulationConfig['system'];
    ctx.handleSystemChange();
    ctx.regenerateTiling();
    ctx.syncUI();
    ctx.markStale();
  }, 'change');

  bindRangeParam(ui, 'm1', 'm1Value', (v) => { c.m1 = v; }, (v) => v.toFixed(1));
  bindRangeParam(ui, 'm2', 'm2Value', (v) => { c.m2 = v; }, (v) => v.toFixed(1));
  bindRangeParam(ui, 'L1', 'L1Value', (v) => { c.L1 = v; }, (v) => v.toFixed(1));
  bindRangeParam(ui, 'L2', 'L2Value', (v) => { c.L2 = v; }, (v) => v.toFixed(1));
  bindRangeParam(ui, 'k1', 'k1Value', (v) => { c.k1 = v; }, (v) => String(v));
  bindRangeParam(ui, 'k2', 'k2Value', (v) => { c.k2 = v; }, (v) => String(v));

  bindRangeParam(ui, 'scWeight', 'scWeightValue', (v) => { c.sculptureWeight = v; }, (v) => String(v));
  bindRangeParam(ui, 'scRod', 'scRodValue', (v) => { c.sculptureRod = v; }, (v) => v.toFixed(1));
  bindRangeParam(ui, 'scAxle', 'scAxleValue', (v) => { c.sculptureAxle = v; }, (v) => v.toFixed(1));
  bindRangeParam(ui, 'scReduction', 'scReductionValue', (v) => { c.sculptureReduction = v; }, (v) => v.toFixed(2));

  ui.bindControl('scN', (v) => {
    c.sculptureN = Math.max(1, Math.min(4, parseInt(v, 10) || 3));
    ctx.handleSystemChange();
    ctx.regenerateTiling();
    ui.updateModeUI(c);
    ui.updatePhaseSpaceInputs(c);
    ctx.markStale();
  }, 'change');

  bindRangeParam(ui, 'rpM0', 'rpM0Value', (v) => { c.rpM0 = v; }, (v) => String(v));
  bindRangeParam(ui, 'rpM1', 'rpM1Value', (v) => { c.rpM1 = v; }, (v) => String(v));
  bindRangeParam(ui, 'rpL0', 'rpL0Value', (v) => { c.rpL0 = v; }, (v) => v.toFixed(1));
  bindRangeParam(ui, 'rpL1', 'rpL1Value', (v) => { c.rpL1 = v; }, (v) => v.toFixed(1));
  bindRangeParam(ui, 'rpA0', 'rpA0Value', (v) => { c.rpA0 = v; }, (v) => v.toFixed(1));
}
